import React from 'react';
import Histogram from './Histogram';
import { GetLevelDistributionDataAPIResponse, UIPosition } from 'types';
import { Loader } from 'ui';
import NewCreatingPositionLoader from '../NewCreatingPositionLoader';

interface Props {
	selectedJobLevel: number;
	setSelectedJobLevel: (value: number) => void;
	jobId: string;
	levelData?: GetLevelDistributionDataAPIResponse;
	activeIndex: number;
	setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
	position?: UIPosition;
	isLoading: boolean;
}

const LevelHistogram = ({
	selectedJobLevel,
	setSelectedJobLevel,
	jobId,
	levelData,
	activeIndex,
	setActiveIndex,
	position,
	isLoading,
}: Props) => {
	return (
		<div className="w-full flex flex-col items-center">
			<div className="w-full">
				{isLoading ? (
					// <Loader />
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
				) : (
					<Histogram
						isLoading={isLoading}
						position={position}
						activeIndex={activeIndex}
						setActiveIndex={setActiveIndex}
						data={levelData}
						selectedJobLevel={selectedJobLevel}
						setSelectedJobLevel={setSelectedJobLevel}
						jobId={jobId || ''}
					/>
				)}
			</div>
		</div>
	);
};

export default LevelHistogram;
